export default __webpack_public_path__ + "525c14fffe08c0feaf4fb78514635b1b.mp3";